"use strict";
////////////////////////////////////////////////
// Model
////////////////////////////////////////////////
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveUsersChartSettingsJSONModel = void 0;
class ActiveUsersChartSettingsJSONModel {
    constructor(serializedState) {
        this.reset = () => {
        };
        this.overwriteFromSerializedState = (serializedState) => {
        };
        this.serialize = () => {
            return {};
        };
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.ActiveUsersChartSettingsJSONModel = ActiveUsersChartSettingsJSONModel;
ActiveUsersChartSettingsJSONModel.getDefaultModel = () => {
    return new ActiveUsersChartSettingsJSONModel().serialize();
};
